import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Rever encomenda',
    [StepEnum.OrderPayment]: 'Pagamento',
  },
};
